var _g, _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefitCardBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 107,
    viewBox: "0 0 210 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_571_9527)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.200012,
    width: 209.6,
    height: 107,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.541 73.6463C240.924 67.6504 235.931 62.567 229.972 58.8149C224.013 55.0627 217.259 52.7492 210.265 52.0649C203.272 51.3805 196.239 52.3449 189.747 54.8786C183.256 57.4123 177.49 61.4428 172.925 66.6381C168.36 71.8335 165.127 78.045 163.492 84.7611C161.857 91.4771 161.866 98.5055 163.52 105.267C165.173 112.029 168.423 118.331 173.003 123.654C177.582 128.977 183.359 133.168 189.858 135.883L197.965 116.353C194.617 114.955 191.642 112.797 189.284 110.055C186.925 107.314 185.251 104.068 184.4 100.586C183.548 97.1033 183.543 93.4835 184.385 90.0246C185.228 86.5657 186.893 83.3666 189.244 80.6909C191.595 78.0152 194.564 75.9394 197.908 74.6345C201.251 73.3295 204.873 72.8329 208.475 73.1853C212.077 73.5378 215.555 74.7293 218.624 76.6617C221.693 78.5942 224.265 81.2122 226.127 84.3002L244.541 73.6463Z",
    fill: "#3D76F8",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.817 23.2423C99.458 1.83642 106.454 -25.3398 127.442 -37.4575C148.431 -49.5752 175.464 -42.0456 187.823 -20.6397C200.181 0.766219 193.186 27.9425 172.197 40.0602C151.209 52.1778 124.175 44.6482 111.817 23.2423ZM169.392 -9.9988C163.027 -21.0233 149.104 -24.9012 138.295 -18.6604C127.485 -12.4195 123.882 1.57691 130.247 12.6014C136.612 23.626 150.535 27.5039 161.345 21.263C172.154 15.0221 175.757 1.02573 169.392 -9.9988Z",
    fill: "#3D76F8",
    fillOpacity: 0.08
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.700012,
    y: 0.5,
    width: 208.6,
    height: 106,
    rx: 15.5,
    stroke: "url(#paint0_linear_571_9527)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.700012,
    y: 0.5,
    width: 208.6,
    height: 106,
    rx: 15.5,
    stroke: "#D0DEFD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_571_9527",
    x1: 8.90211,
    y1: 5.40019,
    x2: 199.067,
    y2: 114.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_571_9527"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.200012,
    width: 209.6,
    height: 107,
    rx: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitCardBlue);
export default __webpack_public_path__ + "static/media/benefitCardBlue.12aaa87dab52ac45308d91b29dfc61b7.svg";
export { ForwardRef as ReactComponent };